var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.419 22.2982C12.3918 20.0172 11.9371 17.505 12.097 14.9939C12.2568 12.4829 13.0261 10.0541 14.3336 7.93222C15.6411 5.81032 17.4447 4.06384 19.5775 2.85428C21.7103 1.64473 24.1034 1.01117 26.5356 1.01221C26.825 1.01221 27.1058 1.02102 27.3952 1.03863C30.4261 1.22645 33.3231 2.39599 35.676 4.38164C38.0289 6.3673 39.7185 9.06846 40.5055 12.1027C41.2925 15.1368 41.1371 18.3503 40.0613 21.2881C38.9855 24.2258 37.0437 26.739 34.511 28.4717",
    stroke: "#EBA256",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3737 1L29.9392 5.41572V8.05775L27.3856 8.93843L26.5345 11.5805L28.2368 14.2225V15.9838L25.6833 16.8645L26.5345 19.5066L28.2368 20.3872L26.5345 22.1486L23.981 21.2679L23.1298 16.8645L21.4275 15.1032H18.8739L16.3204 12.4611V5.41572",
    stroke: "#EBA256",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4512 6.29639L35.0465 8.93842V12.4611L36.7488 13.3304V15.0917L38.4512 15.9838L38.441 17.7452L36.7488 22.1371L39.3024 22.1486",
    stroke: "#EBA256",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 33.5946H7.80936L20.5769 37.998L37.6003 30.0719L34.1956 28.3105L23.1304 30.9526",
    stroke: "#EBA256",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 24.7878L7.76936 24.7764L13.7676 22.1484L24.8328 27.4193L23.1304 30.9526L13.7565 26.5492",
    stroke: "#EBA256",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.53e13ea3a26f8bdcf68282fea4a7f058.svg";
export { ForwardRef as ReactComponent };